import axios from 'axios';
import config from '../config/config.prod';
import { notifySessionExpiredOnce } from './sessionGuard';
import store from '../redux/store';
import { authActions } from '../redux/slices/authSlice';
import { ACCOUNT, SIGNIN } from '../routes/routeConstants';
import toast from 'react-hot-toast';

export const api = axios.create({
  baseURL: config.apiUrl,
  // withCredentials: true,
  headers: { 'Content-Type': 'application/json' },
});

// Optionally attach token automatically
api.interceptors.request.use((req) => {
  const raw = localStorage.getItem('authData');
  if (raw) {
    try {
      const parsed = JSON.parse(raw);
      const token = parsed?.authCredentials?.accessToken ?? parsed?.token;
      if (token) req.headers.Authorization = `Bearer ${token}`;
    } catch {
      /* ignore parse errors */
    }
  }
  return req;
});

api.interceptors.response.use(
  (res) => res,
  (error) => {
    const status = error?.response?.status;

    if (status === 401 || status === 419) {
      notifySessionExpiredOnce((msg) => {
        toast.error(msg); // replace with your toast
      });

      try {
        sessionStorage.clear();
        localStorage.removeItem('authData');
        store.dispatch(authActions.reset());
        store.dispatch({ type: 'LOGOUT' });
      } finally {
        const signinPath = `/${ACCOUNT}/${SIGNIN}`;
        if (window.location.pathname !== signinPath) {
          window.location.replace(signinPath);
        }
      }
    }

    return Promise.reject(error);
  }
);
